module.exports = __webpack_public_path__ + "media/images/emblems/Offizielles_Wappen_von_Stein_am_Rhein-b4a95c7360989b642d554e31f38c73b1.png";